import React from 'react';
import {
  Label,
  ImageUploader,
  ProfileImage,
  UploadText,
  HiddenInput,
  UploaderContainer,
  UploaderInnerContainer,
  CloseIcon,
  ChangeButton,
} from '@app/components/uploader/uploader-components';

type UploaderProps = {
  profileImage?: string;
  fileName?: string;
  onChange: (e: any) => void;
  label?: string;
  selectionLabel?: string;
  borderRadius?: string;
  chooseText?: string;
  changetext?: string;
  onImageDelete?: (e: any) => void;
  id?: string;
  isProfile?: boolean;
};

export default function Uploader({
  profileImage,
  fileName,
  onChange,
  label,
  selectionLabel,
  borderRadius,
  changetext,
  chooseText,
  onImageDelete,
  id,
  isProfile,
}: UploaderProps) {
  const UploadRef: any = React.useRef(null);

  const onRemove = (e: any) => {
    UploadRef.current.value = '';
    onImageDelete && onImageDelete(e);
  };

  return (
    <UploaderContainer>
      <Label>{label}</Label>
      <ImageUploader isProfile={isProfile}>
        <ProfileImage
          isProfile={isProfile}
          image={profileImage}
          borderRadius={borderRadius}
        />
        <UploaderInnerContainer isProfile={isProfile}>
          <div
            style={
              isProfile
                ? {}
                : {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                  }
            }>
            {fileName && !isProfile ? (
              <CloseIcon onClick={onRemove}>Remove</CloseIcon>
            ) : null}
            <UploadText isProfile={isProfile}>
              <HiddenInput
                type="file"
                accept="image/*"
                onChange={onChange}
                id={id}
                multiple
                ref={UploadRef}
              />
              <ChangeButton isProfile={isProfile}>
                {fileName
                  ? changetext
                    ? changetext
                    : 'Change'
                  : selectionLabel
                  ? selectionLabel
                  : chooseText
                  ? chooseText
                  : 'Choose Pic'}
              </ChangeButton>
            </UploadText>
          </div>
        </UploaderInnerContainer>
      </ImageUploader>
    </UploaderContainer>
  );
}
